export enum StatisticsTranslKey {
    OVERVIEW_TITLE = "statistics:overviewTitle",
    OPEN_FORM_SESSIONS_COUNT = "statistics:openFormSessionsCount",
    TOTAL_FORM_SESSIONS_COUNT = "statistics:totalFormSessionsCount",
    SENT_SUBMISSIONS_COUNT = "statistics:sentSubmissionsCount",
    PUBLISHED_FORMS_COUNT = "statistics:publishedFormsCount",
    LOAD_ERROR = "statistics:loadError",
}
